import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=5742f75c&scoped=true&"
import script from "./ItemList.vue?vue&type=script&setup=true&lang=js&"
export * from "./ItemList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ItemList.vue?vue&type=style&index=0&id=5742f75c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5742f75c",
  null
  
)

export default component.exports